import { render } from "./EditCategoryDialog.vue?vue&type=template&id=52ae56e2"
import script from "./EditCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditCategoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__